import { getActiveScenarioId } from 'streams/activeScenario/activeScenario$';
import {
  hasAIGeneratedScenariosFeature,
  hasScenarioFeature,
} from '@ardoq/features';

/**
 * @deprecated connect to `activeScenario$` instead.
 *
 * Github: {@link https://github.com/ardoq/ardoq-packages/blob/3fabfe128211db038b220a19253f32f5df20a41f/apps/ardoq-front/src/js/ardoq/streams/activeScenario%24.ts#L18 activeScenario$}
 */
export const isScenarioMode = () =>
  (hasScenarioFeature() || hasAIGeneratedScenariosFeature()) &&
  Boolean(getActiveScenarioId());
